import * as HPYBET from './happybet';
import * as SNAI from './snai';

import { isSnaiSite } from 'utility/constant';

export default isSnaiSite ? SNAI : HPYBET;
